import SectionLabel from "@/components/base/SectionLabel";
import { whyStartedData } from "@/mocks/aboutData";

export default function WhyStartedSection() {
  return (
    <section id="why-started" className="py-16 md:py-24 bg-background-100">
      <div className="max-w-[1200px] mx-auto px-4 md:px-8">
        {/* Header */}
        <div className="reveal max-w-3xl mx-auto mb-10 md:mb-14">
          <SectionLabel label={whyStartedData.label} className="mb-3" />
          <h2 className="font-heading text-xl md:text-2xl lg:text-3xl font-bold text-foreground-900 mb-6 md:mb-8 leading-[1.7] md:leading-[1.7]">
            {whyStartedData.heading.split("\n").map((line, i, arr) => (
              <span key={i} className={`inline md:block ${i < arr.length - 1 ? "md:mb-1" : ""}`}>
                {line}
              </span>
            ))}
          </h2>
        </div>

        {/* Story text — left-aligned, readable width */}
        <div className="reveal max-w-2xl mx-auto mb-10 md:mb-14">
          <div className="space-y-4 text-sm md:text-base text-foreground-700 leading-[2] text-left">
            {whyStartedData.paragraphs.map((p, i) => (
              <p key={i}>{p}</p>
            ))}
          </div>
        </div>

        {/* Problem questions — left-bordered block */}
        <div className="reveal max-w-2xl mx-auto mb-10 md:mb-14">
          <div className="bg-background-50 border-l-[3px] border-primary-400 rounded-r-lg p-5 md:p-7">
            <div className="space-y-2.5 md:space-y-3 text-sm md:text-base text-foreground-800 leading-[2]">
              {whyStartedData.problemQuestions.map((q, i) => (
                <p key={i} className="font-heading">{q}</p>
              ))}
            </div>
          </div>
        </div>

        {/* Closing paragraphs */}
        <div className="reveal max-w-2xl mx-auto mb-12 md:mb-16">
          <div className="space-y-4 text-sm md:text-base text-foreground-700 leading-[2] text-left">
            {whyStartedData.closingParagraphs.map((p, i) => (
              <p key={i}>{p}</p>
            ))}
          </div>
        </div>

        {/* Story flow — vertical connected steps with numbers and descriptions */}
        <div className="reveal max-w-xl mx-auto mb-12 md:mb-16">
          <div className="flex flex-col">
            {whyStartedData.flowSteps.map((step, idx) => {
              const isLast = idx === whyStartedData.flowSteps.length - 1;
              return (
                <div key={idx} className="flex flex-col items-center">
                  {/* Step block */}
                  <div
                    className={`w-full p-4 md:p-5 rounded-lg ${
                      isLast
                        ? "bg-primary-50 border border-primary-100"
                        : "bg-background-50 border border-background-200/60"
                    }`}
                  >
                    <div className="flex items-start gap-3 md:gap-4">
                      <span
                        className={`flex-shrink-0 text-[10px] md:text-xs font-bold tracking-[0.05em] mt-0.5 ${
                          isLast ? "text-primary-500" : "text-foreground-400"
                        }`}
                      >
                        {step.num}
                      </span>
                      <div>
                        <p
                          className={`text-sm md:text-base font-medium mb-1 ${
                            isLast ? "text-primary-800" : "text-foreground-800"
                          }`}
                        >
                          {step.title}
                        </p>
                        <p className="text-xs md:text-sm text-foreground-600 leading-relaxed">
                          {step.desc}
                        </p>
                      </div>
                    </div>
                  </div>
                  {/* Connector */}
                  {!isLast && (
                    <div className="flex flex-col items-center py-2 md:py-2.5">
                      <div className="w-px h-5 md:h-6 bg-primary-300" />
                      <i className="ri-arrow-down-line text-primary-400 text-xs" />
                    </div>
                  )}
                </div>
              );
            })}
          </div>
        </div>

        {/* Closing emphasis message */}
        <div className="reveal max-w-2xl mx-auto">
          <div className="bg-background-50 border border-background-200/50 rounded-lg p-6 md:p-8">
            <div className="space-y-3 md:space-y-4">
              {whyStartedData.closingMessage.split("\n").map((line, i) => {
                const isLast = i === whyStartedData.closingMessage.split("\n").length - 1;
                return (
                  <p
                    key={i}
                    className={`text-sm md:text-base leading-[2] font-heading ${
                      isLast
                        ? "text-primary-800 font-bold"
                        : "text-foreground-700"
                    }`}
                  >
                    {line}
                  </p>
                );
              })}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}